/**
 * Organization Admin API client
 */
import { apiClient } from './client';
import { User } from '@/types';

export interface OrgAdminUser extends User {
  organization_name?: string;
}

export const organizationAdminApi = {
  // Users
  async getUsers(): Promise<OrgAdminUser[]> {
    const response = await apiClient.get<any[]>('/organization-admin/users');
    return (response || []) as OrgAdminUser[];
  },

  async createUser(data: {
    email: string;
    password: string;
    first_name?: string;
    last_name?: string;
    is_active?: boolean;
    role?: string;
  }): Promise<OrgAdminUser> {
    const response = await apiClient.post<OrgAdminUser>('/organization-admin/users', data);
    return response;
  },

  async updateUser(id: string, data: {
    email?: string;
    password?: string;
    first_name?: string;
    last_name?: string;
    is_active?: boolean;
    role?: string;
  }): Promise<OrgAdminUser> {
    const response = await apiClient.put<OrgAdminUser>(`/organization-admin/users/${id}`, data);
    return response;
  },

  async toggleUserActive(id: string): Promise<OrgAdminUser> {
    const response = await apiClient.patch<OrgAdminUser>(`/organization-admin/users/${id}/toggle-active`);
    return response;
  },
};
